export enum UserManagerMode {
    Owners = 'Owners',
    Members = 'Members'
  }
  export enum OfficeApps {
    Outlook = 0,
    SharePoint = 1,
    Teams = 2,
    Yammer = 3,
  }
  export enum ComplianceStates{
    NotScanned = 0,
    Compliant = 1,
    LessThan2Owners = 2,
    Expired = 3,
    ExpiredAndLessThan2Owners = 4
  }
  export enum ComplianceRule{
    None = "None",
    TwoOwnerEnforcement = "TwoOwnerEnforcement",
    LeaseExpiration = "LeaseExpiration"
  }
  export enum ChangeType{
    UpdateLease = "UpdateLease",
    UpdateLeaseInternal = "UpdateLeaseInternal",
    AddOwner = "AddOwner",
    AddNonValidOwner = "AddNonValidOwner",
    RemoveOwner = "RemoveOwner",
    RemoveNonValidOwner = "RemoveNonValidOwner",
    DeleteGroup = "DeleteGroup",
    DeleteSite = "DeleteSite",
    UpdateDepartment = "UpdateDepartment"
  }
    export enum ArchivedChangeType{
    UpdateRetention = "UpdateRetention",
    AddOwner = "AddOwner",
    RemoveOwner = "RemoveOwner",
    DeArchive = "DeArchive"
  }
  export enum SensitivityLabel{
    InternalOnly = "Internal Only",
    InternalExternal = "Internal - External",
    None = ""
  }